import { BannerTypes } from '@gin-betting/banners';

import useBanners from '../Banners/useBanners';

interface Input {
    zoneId: string;
}

interface Output {
    filteredBanners: BannerTypes.BannerItem[];
    interval: number;
}

const useColorfulBanners = ({ zoneId }: Input): Output => {
    const { banners, interval } = useBanners({ zoneId });
    const filteredBanners = banners.filter(({ id }) => id);

    return {
        filteredBanners,
        interval,
    };
};

export default useColorfulBanners;
